import React from 'react';
import moment from 'moment';

import { T } from '../../../../../../common/locale/translate';
import OfferVariants from '../../../../common/components/offer-variants';
import SearchForm from './search';

export default class Variants extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isOfferVariantsListOpen: false,
      loaderText: T('loading_offer_options'),
      default_duration_min: 7,
      default_duration_max: 15,
      offer_type: props.offer.offer_type
    };
  }

  render() {
    return (
      <section
        className="offer-variants-wrapper"
        ref={() => {
          this.initialize = this.initializeOfferVariants;
        }}
      >
        <SearchForm
          search={this.handleSearch}
          params={this.offerVariantsParams()}
        />
        <OfferVariants
          offer_type={this.state.offer_type}
          ref="offer_variants"
          active={this.state.isOfferVariantsListOpen}
          loaderText={this.state.loaderText}
        />
      </section>
    );
  }

  handleSearch = params => {
    this.setState({ offer_type: params.offer_type }, () => {
      params = Object.assign(this.constantVariantParams(), params);
      this.refs['offer_variants'].appendOfferVariants(params, true);
    });
  };

  initializeOfferVariants = () => {
    this.setState({ isOfferVariantsListOpen: true }, () => {
      this.refs['offer_variants'].appendOfferVariants(
        this.offerVariantsParams()
      );
    });
  };

  constantVariantParams = () => {
    const offer = this.props.offer;
    return {
      hotel_id: offer.subject.id,
      parser: offer.subject.parser
    };
  };

  offerVariantsParams = () => {
    const params = this.props.initialParams;
    const offer = this.props.offer;
    return {
      hotel_id: offer.subject.id,
      parser: offer.subject.parser,
      offer_type: offer.offer_type,
      departure_airports: params.departure_airports
        ? params.departure_airports
        : '',
      boards: params.boards ? params.boards : '',
      price_max_eur: params.price_max_eur ? params.price_max_eur : '',
      adults_number: params.adults_number ? params.adults_number : 1,
      children_ages: params.children_ages ? params.children_ages : '',
      departure_date: params.departure_date
        ? params.departure_date
        : moment().unix(),
      return_date: params.return_date
        ? params.return_date
        : moment()
            .add(3, 'M')
            .unix(),
      duration_min: params.duration_min
        ? params.duration_min
        : this.state.default_duration_min,
      duration_max: params.duration_max
        ? params.duration_max
        : this.state.default_duration_max,
      accommodations: params.accommodations ? params.accommodations : ''
    };
  };
}



// WEBPACK FOOTER //
// ./app/javascript/pages/offer/components/offer_variants/index.js